import React from 'react';
import BestPriceOnDateRoutePanel from "./BestPriceOnDateRoutePanel";
import BestPriceRouteType from "@Pages/stationToStation/types/BestPriceRoute.type";

interface BestPricesListProps {
    bestPriceOnDateData: BestPriceRouteType[],
    index?: string,
    activeTab?: string,
}

function BestPricesList({bestPriceOnDateData}: BestPricesListProps) {
    return (
        <div>
            {bestPriceOnDateData.map((route, index) => (
                <BestPriceOnDateRoutePanel
                    key={route.id}
                    route={route}
                    index={index}
                />
            ))}
        </div>
    );
}

export default BestPricesList;